import React from 'react';
import PropTypes from 'prop-types';
import {FormGroup, FormControl, FormHelperText, InputLabel, Input} from '@material-ui/core';
import {isEmpty} from 'lodash/lang';
import {formShape} from 'rc-form';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditorUploadAdapter from '../CKEditorUploadAdapter';

const CustomCKEditorUploadAdapter = (editor) => {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        return new CKEditorUploadAdapter(loader);
    };
};

export default class RichTextEditorField extends React.Component {
    static propTypes = {
        form: formShape.isRequired,
        name: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        rules: PropTypes.array.isRequired,
        initialValue: PropTypes.string,
        helpText: PropTypes.string.isRequired
    };
    static defaultProps = {
        rules: [],
        initialValue: '',
        helpText: '',
    };

    constructor(props) {
        super(props);
        const {
            name,
            rules,
            initialValue,
            form: {getFieldProps},
        } = props;

        this.ckEditorInputElement = this.ckEditorInputElement.bind(this);
        this.ckEditorChange = this.ckEditorChange.bind(this);
        this.ckEditorRef = React.createRef();
        this.inputFieldProps = getFieldProps(name, {
            validate: [
                {trigger: 'onChange', rules},
            ],
            initialValue,
        });
    }

    ckEditorChange = (event, editor) => {
        this.inputFieldProps.onChange(editor.getData());
        if (this.props.onChange) {
            this.props.onChange(editor.getData());
        }
    };

    ckEditorInputElement() {
        const {name, initialValue} = this.props;

        return (
            <div className="ck-editor-quiz-wrapper">
                <CKEditor
                    id={name}
                    ref={this.ckEditorRef}
                    data={initialValue || ''}
                    name={name}
                    editor={ClassicEditor}
                    onChange={(e, editor) => this.ckEditorChange(e, editor)}
                    config={{
                        image: {
                            toolbar: ['imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full',
                                'imageStyle:alignRight'],
                            styles: [
                                'full',
                                'alignLeft',
                                'alignRight'
                            ]
                        },
                        extraPlugins: [CustomCKEditorUploadAdapter]
                    }}
                />
            </div>
        );
    }

    render() {
        const {
            name,
            label,
            rules,
            initialValue,
            form: {getFieldProps, getFieldError},
            helpText,
            ...restProps
        } = this.props;
        const errors = getFieldError(name);
        const hasError = !isEmpty(getFieldError(name));

        return (
            <FormGroup className="mui-form-group">
                <FormControl error={hasError}>
                    <InputLabel htmlFor={`${name}-button`} shrink>{label}</InputLabel>
                    <Input
                        id={name}
                        name={name}
                        multiline={true}
                        label={label}
                        disableUnderline={true}
                        inputComponent={this.ckEditorInputElement}
                        inputProps={{
                            ...restProps,
                            ...getFieldProps(name, {
                                validate: [
                                    {trigger: 'onChange', rules},
                                ],
                                initialValue,

                            }),
                        }}
                        error={hasError}
                    />
                    {helpText && <FormHelperText error={false}>{helpText}</FormHelperText>}
                    {hasError && errors.map((error, index) =>
                        <FormHelperText key={`ck-editor-field-error-${index}`} error={true}>
                            {error}</FormHelperText>)}
                </FormControl>
            </FormGroup>
        );
    }
}
